import { render, staticRenderFns } from "./ModalAddCustomField.vue?vue&type=template&id=1f664e20&"
import script from "./ModalAddCustomField.vue?vue&type=script&lang=js&"
export * from "./ModalAddCustomField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports